export default "__VITE_ASSET__BMD23wPQ__"